import React from "react";
import SecurityIntake from "../features/security/SecurityIntake";
import DemandPageHeader from "../components/DemandPageHeader";
import DemandSelector from "../components/DemandSelector";
import { useDemandId } from "../context/DemandContext";

export default function SecurityPage() {
  // Was: no demandId at all — SecurityIntake defaulted to "DEM-001" internally, so
  // this screen pre-screened the wrong demand no matter which one you were working on.
  const { demandId, setDemandId } = useDemandId();

  return (
    <div>
      <DemandPageHeader
        title="Security Pre-Screen"
        description="Data classification, control baseline and gap analysis before TAB"
        breadcrumbPath="Security Pre-Screen"
      >
        <DemandSelector currentDemandId={demandId} stage="security" onDemandChange={setDemandId} />
      </DemandPageHeader>
      {demandId ? (
        <SecurityIntake demandId={demandId} />
      ) : (
        <div style={{ padding: 40, textAlign: "center", color: "var(--cares-text-label)" }}>
          Select a demand to run the security pre-screen.
        </div>
      )}
    </div>
  );
}
